import { render, staticRenderFns } from "./PedidoDetalle.vue?vue&type=template&id=3be85385&scoped=true&"
import script from "./PedidoDetalle.vue?vue&type=script&lang=js&"
export * from "./PedidoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./PedidoDetalle.vue?vue&type=style&index=0&id=3be85385&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be85385",
  null
  
)

export default component.exports